
























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PicUpload from "@/components/picUpload/index.vue";
@Component({
  name: "uploadAddon",
  components: {
    PicUpload,
  },
})
export default class UploadAddon extends Vue {
  private zItem!: any;
  @Prop({ type: Number, default: {} }) zIndex!: number;
  @Prop({ type: Boolean, default: true }) Required!: boolean;
  @Watch("zIndex", { immediate: true })
  @Prop({ type: Object, default: {} })
  item!: any;
  @Watch("item", { immediate: true, deep: true })
  dataChage(value: any) {
    this.zItem = value;
  }
}
